import { render, staticRenderFns } from "./ImpactDetail.vue?vue&type=template&id=04d95052&scoped=true"
import script from "./ImpactDetail.vue?vue&type=script&lang=js"
export * from "./ImpactDetail.vue?vue&type=script&lang=js"
import style0 from "./ImpactDetail.vue?vue&type=style&index=0&id=04d95052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d95052",
  null
  
)

export default component.exports